import errorResponseHandler from "configs/axios/errorResponseHandler";
import { FETCH_DATA, POST_DATA, POST_DATA_FAILURE } from "../types";
import axios from "configs/axios";

export const fetchData = (url, data) => (dispatch) => {
  return axios.get(url).then((response) => {
    dispatch({
      type: FETCH_DATA,
      payload: {
        [data]: response.data,
      },
    });
    return response.data;
  });
};

export const fetchDataSeller = (url, data) => async (dispatch) => {
  try {
    return await axios.get(url).then((response) => {
      dispatch({
        type: FETCH_DATA,
        payload: {
          [data]: response.data,
        },
      });
      return response.data;
    });
  } catch (error) {
    console.log(error);
  }
};

export const postData = (url, data) => (dispatch) => {
  dispatch({
    type: POST_DATA,
    payload: {
      loading: true,
    },
  });

  try {
    return axios.post(url, data).then((response) => {
      dispatch({
        type: POST_DATA,
        payload: {
          loading: false,
          [data]: response.data,
        },
      });
      return response.data;
    });
  } catch (error) {
    dispatch({
      type: POST_DATA_FAILURE,
      payload: {
        loading: false,
        errorMessage: error.response.data.message,
      },
    });
    return error.response.data;
  }
};
